var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 25 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m12.692 12.221 12.215.021.007.007v-.832C24.914 5.126 19.798.01 13.504.01h-.833l.021 12.211Zm10.524-1.635-8.874-.014-.007-.007-.014-8.87c4.721.401 8.493 4.171 8.895 8.89Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.914 14.183c0-5.427 4.402-9.828 9.83-9.828v.007h.326v9.446l9.497-.02c.007.131.007.263.007.395 0 5.426-4.402 9.827-9.83 9.827s-9.83-4.4-9.83-9.827Zm8.527-8.1c-3.913.626-6.905 4.02-6.905 8.1 0 4.525 3.681 8.205 8.208 8.205 4.111 0 7.522-3.035 8.118-6.979l-7.792.021H9.44V6.082Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Chart.e4fd5b0f64ba5f5ea7bbf538347728e1.svg";